import { CSSProperties, PropsWithChildren, ReactNode } from 'react';
type FrameProps = PropsWithChildren<{ title?: ReactNode; style?: CSSProperties; styleInner?: CSSProperties; className?: string }>;
function Frame({ title, children, style = {}, styleInner = {}, className = '' }: FrameProps) {
    return <section className={`fantasy-frame ${className}`} style={style}>
        {title && <h2 className="fantasy-frame__title">{title}</h2>}
        <div style={styleInner}>{children}</div>
    </section>;
}
export default Frame;
